import { gql } from '@apollo/client';

export const DECLINE_QUOTE = gql`
  mutation declineQuote($quote_id: String!) {
    declineQuote(quoteId: $quote_id) {
      complete
    }
  }
`;
